module.exports = __webpack_public_path__ + "img/niño62.3c727305.jpg";